import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-smart-header',
  templateUrl: './smart-header.component.html',
  styleUrls: ['./smart-header.component.css']
})
export class SmartHeaderComponent implements OnInit {

  showShopping = false;
  showSearch = false;
  showBurger = false;
  

  @ViewChild('testimonial') testimonial: ElementRef<HTMLDivElement>;
  @ViewChild('packsoffer') packsoffer: ElementRef<HTMLDivElement>;
  @ViewChild('ourteam') ourteam: ElementRef<HTMLDivElement>;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  scrollToElement(label): void {

    switch(label){
      case 'testimonial':
        this.testimonial.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'packsoffer':
        this.packsoffer.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'ourteam':
        this.ourteam.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
    }
  }

  getShoppingCart(){
    
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }
}
